<template>
  <v-dialog
    v-model="showDialogToken"
    max-width="500px"
    persistent
    :retain-focus="false"
    transition="dialog-bottom-transition"
    style="z-index: 1;"
  >
    <template v-slot:activator="{}">
      <v-btn
        class="primary text-subtitle-1"
        @click="openDialogToken()"
        style="text-transform: none;"
      >
        <!-- class="my-6 pa-5 primary text-subtitle-1" -->
        <v-icon>mdi-sale-outline</v-icon>
        <div class="ml-2">{{ $t("redeemToken") }}</div>
      </v-btn>
    </template>
    <v-card class="colorDominant">
      <div class="d-flex justify-end pa-2">
        <v-toolbar
          class="transparent elevation-0"
          dense
          transparent
        >
          <v-toolbar-title>
            {{ $t("insertToken") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDialogToken()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </div>
      <div class="pa-6 pt-0">
        <v-text-field
          v-model="token"
          ref="tokenInput"
          name="token"
          label="Token"
          clearable
          outlined
          tabindex="107"
          autocapitalize="off"
          type="text"
          :counter="8"
          maxlength="8"
          :rules="[
            rules.lengthToken,
          ]"
        ></v-text-field>
        <v-alert
          v-show="msgTokenAlert"
          type="warning"
          text
          dense
          border="left"
        >
          {{ msgTokenAlert }}
        </v-alert>
        <DialogConfirmToken
          type="dashMyPromotions"
          :token="token"
          :isValidToken="isValidToken"
          @closeDialogToken="closeDialogToken(true)"
          @emitMsgTokenAlert="emitMsgTokenAlert"
        />
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import { validate } from "@/util/form-validate";
import DialogConfirmToken from "../../components/promotions/dialog-confirm-token.vue";

export default {
  name: "dialog-token",
  components: { DialogConfirmToken },
  data: () => ({
    token: "",
    rules: {
      lengthToken: validate.lengthToken,
    },
    isValidToken: false,
    msgTokenAlert: "",
  }),
  mounted() {
    if (this.$route.query.openDialogToken) this.openDialogToken();
  },
  watch: {
    "$route.query.openDialogToken"(val) {
      if (val) this.openDialogToken();
    },
    token() {
      this.isValidToken = this.$refs.tokenInput.validate();
      this.msgTokenAlert = "";
    },
  },
  computed: {
    showDialogToken() {
      return this.$store.state.showDialogToken;
    },
  },
  methods: {
    openDialogToken() {
      this.isValidToken = false;
      this.msgTokenAlert = "";

      this.$store.commit("showDialogToken", true);
    },
    closeDialogToken(fromDialogConfirmToken) {
      this.token = "";

      if (this.$route.query.openDialogToken) {
        let query = Object.assign({}, this.$route.query);
        delete query.openDialogToken;
        this.$router.replace({ query });
      }

      // Enviar emit somente se for resgatado um token para atualizar
      // lista de promoções com a promoção atual resgatada
      if (fromDialogConfirmToken) this.$emit("refreshPromotions");

      this.$store.commit("showDialogToken", false);
    },
    emitMsgTokenAlert(val) {
      this.msgTokenAlert = val;
    },
  },
};
</script>
